export type ApiKeyStatus = 'active' | 'revoked' | 'inactive';

export interface ApiKey {
  id: string;
  name: string;
  key: string;
  status: ApiKeyStatus;
  created_at: string;
  last_used_at: string | null;
  provider_status?: string;
  keyPrefix: string;
  scopes: string[];
  isActive: boolean;
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdAt: string;
  updatedAt: string | null;
  rateLimitPerMinute: number;
  rateLimitPerDay: number;
  description: string | null;
}

export interface CreatedApiKey {
  success: boolean;
  message?: string;
}

export interface BackofficeApiKey extends ApiKey {
  userId: string;
  clientEmail: string;
  clientName: string | null;
  clientCompany: string | null;
}
